<template>
  <div class="center_box">
    <Header style="margin-top:30px;"></Header>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <router-link to="/">{{$t('message.homepage')}}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.product')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.CalculationInertia')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div><h1 style="font-size:34px;padding-top:20px;padding-bottom:20px;">{{$t('message.CalculationInertia')}}</h1></div>
    <ParamInput v-on:listenPageChange="listenPageChange" v-show="ParamInputPage"></ParamInput>
    <BackTop></BackTop>
  </div>
</template>
<script>
import BackTop from '../BackTop'
import ParamInput from './ParamInput'
import Header from '../Header'
export default {
  name: 'MomentInertia',
  components: {
    ParamInput,
    BackTop,
    Header
  },
  data () {
    return {
      ParamInputPage: true
    }
  },
  methods:{
    listenPageChange:function(data) {}
  }
}
</script>
<style scoped>
  .center_box {
    width:75%;
    margin:0 auto;
    height:100%;
  }
  .el-breadcrumb {
    font-size: 18px;
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/MomentInertia/MomentInertia.vue